/**
 * Get the tail on the right of the string separate
 *
 * @param {string} path
 *
 * @return {string}
 */
export var getParentPath = function (path) {
    var lastIndex = path.lastIndexOf('.');
    if (lastIndex === -1) {
        return '';
    }
    return path.substring(0, lastIndex);
};
//# sourceMappingURL=getParentPath.js.map